import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { Button } from '@vestigas/ui';

export type SavedFilterDeleteAction = {
  readonly cancelText: string;
  readonly confirmText: string;
  readonly description: string;
  readonly isPending: boolean;
  readonly text: string;
  readonly title: string;
  readonly onConfirm: () => void;
};

type SavedFilterDeleteConfirmationDialogProps = {
  readonly deleteAction: SavedFilterDeleteAction;
  readonly isOpen: boolean;
  readonly onClose: () => void;
};

export function SavedFilterDeleteConfirmationDialog({
  deleteAction,
  isOpen,
  onClose,
}: SavedFilterDeleteConfirmationDialogProps) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={isOpen}
      slotProps={{
        paper: {
          className: 'rounded-md p-0',
        },
      }}
      onClose={() => {
        if (!deleteAction.isPending) onClose();
      }}
    >
      <div className="flex flex-col gap-6 p-6">
        <DialogTitle className="text-tiga-text p-0 text-xl font-semibold">
          {deleteAction.title}
        </DialogTitle>
        <DialogContent className="p-0">
          <DialogContentText className="text-tiga-text-default">
            {deleteAction.description}
          </DialogContentText>
        </DialogContent>
        <footer className="flex justify-end gap-3">
          <Button
            buttonStyle="secondary"
            disabled={deleteAction.isPending}
            text={deleteAction.cancelText}
            type="button"
            onClick={onClose}
          />
          <Button
            buttonStyle="primary"
            color="error"
            disabled={deleteAction.isPending}
            loading={deleteAction.isPending}
            text={deleteAction.confirmText}
            type="button"
            onClick={deleteAction.onConfirm}
          />
        </footer>
      </div>
    </Dialog>
  );
}
